import { Paper, Stack, Box } from '@mui/material'
import { FileIcon, FileName, FileTypeLabel } from './index'
import type { FileType } from './FileIcon'

interface CardFilePreviewProps {
  fileType: FileType
  fileName: string
  isRefreshing: boolean
  onClick: () => void
}

export const CardFilePreview = ({
  fileType,
  fileName,
  isRefreshing,
  onClick,
}: CardFilePreviewProps) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 1,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
        opacity: isRefreshing ? 0.7 : 1,
      }}
      onClick={onClick}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{ color: 'primary.main' }}>
          <FileIcon fileType={fileType} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <FileName name={fileName} variant="card" />
          <FileTypeLabel fileType={fileType} />
        </Box>
      </Stack>
    </Paper>
  )
}
